import { v4 as uuidv4 } from 'uuid';
import mock from '../config/mock';

mock.onGet('/api/agents').reply(200, {

    agents: [
        {
            id: uuidv4(),
            name: 'agent001',
            email: 'asd@asd.com',
            contact: '0987654321',
        },
        {
            id: uuidv4(),
            name: 'agent002',
            email: 'qwe@qwe.com',
            contact: '0987654321',
        },
        {
            id: uuidv4(),
            name: 'agent003',
            email: 'bnm@bnm.com',
            contact: '0987654321',
        },
    ]
});